'use client';

import { FC, useContext } from 'react';

import { Button } from 'components/ui/button';
import ApplyLoginContext, { ModalTabs } from 'app/_context/ApplyLoginContext';

import { ILandingConfig } from 'types';

interface IJoinCommunityButtonProps {
  appConfig: ILandingConfig;
  className?: string;
  icon: JSX.Element | null;
  iconLeft?: boolean;
  title: string;
}

export const JoinCommunityButton: FC<IJoinCommunityButtonProps> = (props) => {
  const {
    appConfig,
    className,
    icon,
    iconLeft,
    title,
  } = props;

  const { setApplyTab } = useContext(ApplyLoginContext);

  return (
    <Button
      className={`${className} ${iconLeft ? 'flex-row-reverse' : ''}`}
      size="x-large"
      variant={appConfig.buttonVariant}
      onClick={() => setApplyTab(ModalTabs.APPLY)}
    >
      {title}
      {icon}
    </Button>
  );
}
